const inputEmptyText = {
  default: '--',
  select: '--',
  datepicker: '--'
};

export default inputEmptyText;
